import { Component, input, OnDestroy, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatDividerModule } from '@angular/material/divider';

export interface FilterOption {
  id: string;
  label: string;
  selected: boolean;
}

export interface SearchEvent {
  searchTerm: string;
  activeFilters: string[];
}

@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatCheckboxModule,
    MatDividerModule
  ]
})
export class SearchbarComponent implements OnDestroy {
    readonly filterOptions = input<FilterOption[]>([]);
    readonly searchChange = output<SearchEvent>();
    public searchTerm:string = '';
    private searchSubject = new Subject<string>();
    private subscription: Subscription;

    constructor() {
        // Set up debounced search with 300ms delay
        this.subscription = this.searchSubject
        .pipe(
            debounceTime(300),
            distinctUntilChanged()
        )
        .subscribe(searchTerm => {
            this.emitSearchChange(searchTerm);
        });
    }
    
    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    onSearchInput(value: string): void {
        this.searchTerm = value;
        this.searchSubject.next(value);
    }

    onFilterChange(): void {
        this.emitSearchChange(this.searchTerm);
    }

    private emitSearchChange(searchTerm: string): void {
        const activeFilters = this.filterOptions()
        .filter(option => option.selected)
        .map(option => option.id);

        this.searchChange.emit({
            searchTerm,
            activeFilters
        });
    }

    clearSearch(): void {
        this.searchTerm = '';
        this.searchSubject.next('');
    }

}